// Header name constants
export const HEADERS = {
  CLIENT_PLATFORM: 'x-client-platform',
  ACCESS_TOKEN: 'x-access-token',
  API_KEY: 'x-api-key',
  ORGANIZATION_ID: 'OrganizationId',
};

export const CLIENT_PLATFORM_VALUE = 'web';
